import { useRef } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

import { useDispatch } from "react-redux";
import { socialLogin } from "../../actions/auth";
import styles from "../../css/common.module.css";

function New2GoogleLoginButton() {

    const dispatch = useDispatch();

    // 숨겨진 GoogleLogin 버튼을 참조하기 위한 ref
  const googleLoginButtonRef = useRef(null);

  // 커스텀 버튼 클릭 시 호출될 함수
  const handleCustomButtonClick = () => {
    // ref를 통해 숨겨진 div 안의 실제 버튼을 찾아 클릭 이벤트를 발생시킴
    const internalGoogleButton = googleLoginButtonRef.current?.querySelector('div[role="button"]');
    if (internalGoogleButton) {
      internalGoogleButton.click();
    }
  };

  // 로그인 성공 시 호출될 콜백 함수
  const handleLoginSuccess = (credentialResponse) => {
    // console.log("Login Success: ", credentialResponse);

    // credentialResponse.credential은 암호화된 JWT 토큰입니다.
    const idToken = credentialResponse.credential;

    // JWT 토큰을 디코딩하여 사용자 정보를 추출합니다.
    const decodedToken = jwtDecode(idToken);
    
    // console.log("Decoded Token: ", decodedToken);

    // 추출한 사용자 정보
    // decodedToken.sub, // 사용자의 고유 Google ID
    // decodedToken.name,
    // decodedToken.email,

    // 여기서 디스패치로~
    dispatch(socialLogin("google", decodedToken.sub, decodedToken.email, decodedToken.name))
    .then(data => 
    {
        // console.log("socialLogin data : ", data);
        // if (data.success)
        //     navigate("/dashboard/NoticeListClient/notice");
    })
    .catch(e => {
        console.log(e);
    });

  };

  // 로그인 실패 시 호출될 콜백 함수
  const handleLoginError = () => {
    console.log('Login Failed');
  };

  return (
    <div>
        {/* 1. 사용자가 실제로 클릭할 예쁜 커스텀 버튼 */}
      <button type="button" onClick={handleCustomButtonClick} className={styles.google}>
        <img src={process.env.PUBLIC_URL + '/assets/logo_googleg_48dp.png'} alt="google logo" />
      </button>
        
        {/* 2. 화면에는 보이지 않지만 실제 로그인을 처리할 GoogleLogin 컴포넌트 */}
      <div ref={googleLoginButtonRef} style={{ display: 'none' }}>
        <GoogleLogin
          onSuccess={handleLoginSuccess}
          onError={handleLoginError}
        //   useOneTap  // 이 옵션을 사용하면 페이지 로드 시 자동으로 FedCM 프롬프트가 뜹니다.
          useOneTap={false}       // FedCM 기반 One Tap 비활성화
          ux_mode="popup"         // 팝업 방식 강제 사용 (FedCM 우회)
          type="standard" // standard 타입 버튼이 DOM 구조를 찾기 더 용이합니다.
        />
      </div>
    </div>
  );
}

export default New2GoogleLoginButton;